import axios from 'axios';
import  { serviceUrl } from '../../App';

export const getPlan = (event_id: any) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`plan?where=` + event_id
  );
};
export const getOrderByPlan = (cond: string, timezoneOffset:number) => {
  var query = process.env.REACT_APP_API_GLOBAL_URL+`order`+`/${timezoneOffset}?where=` + cond;
  return axios.get(query);
};
export const getOrderByMergedPlan = (cond: string) => {
  var query = process.env.REACT_APP_API_GLOBAL_URL+`order/order-merge-by-planned-order?where=` + cond;
  return axios.get(query);
};
export const AddPlan = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`plan/create`,
    obj,
    { headers }
  );
};

export const EditPlan = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`plan/update`, obj, {
    headers,
  });
};

export const DeletePlan = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`plan/delete`,
    obj,
    { headers }
  );
};
export const AddPlanOrder = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`plan/plan-order-create`,
    obj,
    { headers }
  );
};
export const EditPlanOrder = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`plan/plan-order-update`,
    obj,
    { headers }
  );
};
export const DeletePlanOrder = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`plan/plan-order-delete`,
    obj,
    { headers }
  );
};
